"use strict";
var exportTypedArrayMethod = require("../internals/array-buffer-view-core").exportTypedArrayMethod;
var fails = require("../internals/fails");
var globalThis = require("../internals/global-this");
var uncurryThis = require("../internals/function-uncurry-this");
var Uint8Array = globalThis.Uint8Array;
var Uint8ArrayPrototype = Uint8Array && Uint8Array.prototype || {};
var arrayToString = [].toString;
var join = uncurryThis([].join);
if (fails(function() {
  arrayToString.call({});
})) {
  arrayToString = function toString() {
    return join(this);
  };
}
var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString !== arrayToString;
exportTypedArrayMethod("toString", arrayToString, IS_NOT_ARRAY_METHOD);
